import React, { createContext, useContext, useEffect, useState } from "react";

const WishlistContext = createContext(null);
const KEY = "alteza_wishlist_v1";

export const WishlistProvider = ({ children }) => {
  const [ids, setIds] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setIds(JSON.parse(raw));
    } catch {}
  }, []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids]);

  const toggle = (productId) =>
    setIds((prev) => (prev.includes(productId) ? prev.filter((x) => x !== productId) : [...prev, productId]));

  const has = (productId) => ids.includes(productId);
  const remove = (productId) => setIds((prev) => prev.filter((x) => x !== productId));
  const clear = () => setIds([]);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, remove, clear, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
